import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./app";                 // 🔥 FIX: Capital "A" (React requires this)
import { CartProvider } from "./context/CartContext";
import CartDrawer from "./Components/CartDrawer";

import "./styles/tailwind.css"; // ✔️ Keep - required for Tailwind
// import "./index.css";         // ❌ Remove if unused

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <CartProvider>
        <App />
        <CartDrawer />
      </CartProvider>
    </BrowserRouter>
  </React.StrictMode>
);
